export default __webpack_public_path__ + "images/deloitte-logo.c3f298ec12b1a3003aac2d3f1f54edb4.png";